import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {ROUTES} from '@/root/constants/routes';
import {useCardDetails} from '@/root/queries/cards';

import CardInfoField from '@/shared/components/CardInfo/Field';
import CardInfoFooter from '@/shared/components/CardInfo/Footer';
import Halfview from '@/shared/components/Halfview';
import {TIARA_DETAIL_ACTION, TIARA_DETAIL_PAGE_NAME} from '@/shared/constants/tiara';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';
import useTiara from '@/shared/hooks/useTiara';
import {CardSummary} from '@/shared/models/card';
import {useHalfviewStore} from '@/shared/stores/halfview';
import {getKeys} from '@/shared/utils/keys';

const TITLE_BY_SUMMARY_FIELD: Record<keyof CardSummary, string> = {
  cardName: '카드명',
  partner: '발급처',
  validPeriod: '유효기간'
};

const CardDetailHalfview = () => {
  const {groupCode = '', cardId = ''} = useParams<{cardId: string; groupCode: string}>();
  const {trackEvent} = useTiara({pageName: TIARA_DETAIL_PAGE_NAME.CARD_INFO});
  const {classnames, setClassnames, closeHalfview} = useHalfviewStore();
  const navigate = useAdvancedNavigate();
  const {card} = useCardDetails(cardId);

  const onExited = () => {
    navigate(ROUTES.CARD_GROUP, {pathParams: {groupCode}});
  };

  useHistoryBackAOS(() => {
    closeHalfview();
  }, []);

  useEffect(() => {
    setClassnames('modal_info');
  }, []);

  useEffect(() => {
    if (card) {
      trackEvent({
        action: TIARA_DETAIL_ACTION.CARD_INFO_VIEW,
        customProps: {card_name: card?.summaryInfo.cardName ?? '', group_code: groupCode}
      });
    }
  }, [card]);

  return (
    <Halfview.Wrapper classnames={classnames} onExited={onExited}>
      <Halfview.Header>
        <Halfview.Title headingLevel="h3">카드 정보</Halfview.Title>
      </Halfview.Header>
      <Halfview.Body>
        <div className="inner_g">
          {card ? (
            <>
              <div className="area_info">
                <span className="bg_img" style={{backgroundImage: `url(${card.backgroundImageUrl})`}}></span>
                <div className="group_list">
                  {card.info.map((info) => (
                    <CardInfoField key={info.title} {...info} />
                  ))}
                </div>
                <div className="group_list">
                  {getKeys(card.summaryInfo).map((key) => (
                    <CardInfoField key={key} title={TITLE_BY_SUMMARY_FIELD[key]} value={card.summaryInfo[key]} />
                  ))}
                </div>
              </div>
              <CardInfoFooter className="type11" descriptions={card.descriptions} />
            </>
          ) : (
            <Halfview.Loading />
          )}
        </div>
      </Halfview.Body>
    </Halfview.Wrapper>
  );
};

export default CardDetailHalfview;
